import NextButton from '../../Buttons/NextButton/NextButton';
import './AccordionBlock.css';
import BlockContent from './BlockContent/BlockContent';
import BlockHeader from './BlockHeader/BlockHeader';
import { FormElement } from './FormElements';

function AccordionBlock(props:{
    header?: string,
    paragraph?: string,
    needsNextButton: boolean,
    elements: FormElement[],
    buttonAction?: () => void,
    inputAction?: () => void,
    buttonDisabled: boolean,
}){
    return(
        <div className='accordion-block df fdc aic jcsb'>
            <BlockHeader 
                heading={ props.header } 
                paragraph={ props.paragraph }
            />
            <BlockContent 
                elements={ props.elements }
            />
            { props.needsNextButton && <NextButton 
                buttonTitle='შემდეგი' 
                onClick={
                    () => {
                        props.buttonAction && props.buttonAction();
                        props.inputAction && props.inputAction();
                    }
                } 
                disabled={ props.buttonDisabled }
            /> }
        </div>
    )
}

export default AccordionBlock;